// extracted by mini-css-extract-plugin
export default {"orgPhoto":"styles_org-photo__VD5iS"};